import {generateUUIDV4} from "../../common/functions";
import React, {FC} from "react";
import Shelf from "../../components/Shelf";
import {DrawerContext} from "./DrawerProvider.context";
import {DrawerProviderProps} from "./DrawerProvider.types";
import Drawer from "../../components/Drawer";

export const DrawerProvider: FC<DrawerProviderProps> = ({children}) => {
    const [elements, setElements] = React.useState<{
        element: React.ReactNode;
        size: 'medium' | 'large';
        id: string;
        open: boolean;
        onClose?: (closeAll?: boolean) => unknown;
    }[]>([]);

    const push = (
        element: React.ReactNode,
        size: 'medium' | 'large',
        onClose?: () => unknown
    ) => {
        const id = generateUUIDV4();
        setElements([...elements, {element, size, id, onClose, open: true}]);
        return id;
    };

    const unshift = (
        element: React.ReactNode,
        size: 'medium' | 'large',
        onClose?: () => unknown
    ) => {
        const id = generateUUIDV4();
        setElements([{element, size, id, onClose, open: true}, ...elements]);
        return id;
    };

    const close = (id: string): void => {
        setElements(elements.map(element => {
            if (element.id === id) {
                element.open = false;
                element.onClose?.();
            }
            return element;
        }));
    }

    const closeAll = () => {
        elements.forEach(({onClose}) => {
            onClose?.();
        });
        setElements(elements.map(element => ({...element, open: false})));
    };

    const closeMe = () => {
        console.error("Call closeMe() inside Drawer's children");
    };

    return (
        <>
            <DrawerContext.Provider
                value={{push, unshift, closeAll, closeMe, close}}
            >
                {children}
                <Shelf open={elements.some((elements) => elements.open)} onClose={closeAll}>
                    {elements.map((element) => {
                        const closeMeInner = () => {
                            element.onClose?.();
                            setElements(elements.map(el => ({...el, open: element.id === el.id ? false : el.open})));
                        }

                        return (
                            <Drawer
                                key={element.id}
                                open={element.open}
                                size={element.size}
                                onAnimationEnd={() => {
                                    setElements(elements.filter(el => el.id !== element.id));
                                }}
                            >
                                <DrawerContext.Provider
                                    value={{
                                        push,
                                        unshift,
                                        closeAll,
                                        closeMe: closeMeInner,
                                        close,
                                    }}
                                >
                                    {element.element}
                                </DrawerContext.Provider>
                            </Drawer>
                        );
                    })}
                </Shelf>
            </DrawerContext.Provider>
        </>);
}
